/**
 * Public marketing site identity used for SEO, Open Graph, and structured data.
 * Override with REACT_APP_SITE_URL in production (no trailing slash).
 */
export const SITE_URL = (process.env.REACT_APP_SITE_URL ?? 'https://loopcast.io').replace(/\/$/, '');

export const SITE = {
  name: 'Loopcast',
  url: SITE_URL,
  email: 'merhaba@loopcast.io',
  localeDefault: 'tr_TR',
  twitterHandle: '@prompt.overflowed',
  /** Absolute OG/Twitter share image. Replace when a dedicated asset is available. */
  ogImage: `${SITE_URL}/og-image.png`,
  sameAs: ['https://instagram.com/prompt.overflowed'],
} as const;
